module.exports = __webpack_public_path__ + "static/img/休眠.4072cc0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/车辆/电力工程车/休眠.png
// module id = 8cDY
// module chunks = 76